import AllPodcastsView from "@features/media-academy/view/all-podcasts-view";

const AllPodcasts = () => {
  return <AllPodcastsView />;
};

export default AllPodcasts;
